import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarDismiss } from '@angular/material/snack-bar';

import { EpcotConfig } from '@frontend/sports/common/client-config-data-access';
import { Observable } from 'rxjs';

import { ToasterComponent } from './toaster.component';

export interface ToasterConfig {
    icon?: string;
    duration?: number;
    panelClass?: string;
}

export interface ToasterModel {
    icon?: string;
    message: string;
    dismiss: () => void;
}

export interface Toaster {
    dismissed: Observable<MatSnackBarDismiss>;
    opened: Observable<void>;
    dismiss(): void;
}

@Injectable({ providedIn: 'root' })
export class ToasterService {
    private isEpcotEnabled: boolean;
    constructor(
        private snackBar: MatSnackBar,
        private epcotConfig: EpcotConfig,
    ) {
        this.isEpcotEnabled = this.epcotConfig.isEnabled;
    }

    open(message: string, { icon, duration, panelClass }: ToasterConfig = {}): Toaster {
        const toasterPanelClass = this.isEpcotEnabled ? 'toaster-panel' : 'row-toaster-panel';
        const panelClasses = [toasterPanelClass];
        if (panelClass) {
            panelClasses.push(...panelClass.split(' '));
        }
        const toaster = this.snackBar.openFromComponent<ToasterComponent, ToasterModel>(ToasterComponent, {
            data: {
                icon,
                message,
                dismiss: () => {
                    toaster.dismiss();
                },
            },
            horizontalPosition: 'left',
            verticalPosition: 'bottom',
            panelClass: panelClasses,
            duration,
        });

        return {
            dismiss: () => {
                toaster.dismiss();
            },
            dismissed: toaster.afterDismissed(),
            opened: toaster.afterOpened(),
        };
    }

    dismiss(): void {
        this.snackBar.dismiss();
    }
}
